import axios from "axios";

// Production uses the same domain through Nginx (/api).
// Local development may set REACT_APP_BACKEND_URL=http://127.0.0.1:8000.
const configuredBackend = (process.env.REACT_APP_BACKEND_URL || "").trim();

export const BACKEND_URL = configuredBackend.replace(/\/$/, "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
export const SERVER_STATUS_EVENT = "tripleside:server-status";

const publishServerStatus = (status, message = "") => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SERVER_STATUS_EVENT, { detail: { status, message } }));
};

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

// ✅ FIX UTAMA: KIRIM TOKEN KE SEMUA REQUEST
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ts_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// ✅ RESPONSE NORMAL (JANGAN DIUTAK-ATIK LAGI)
api.interceptors.response.use(
  (response) => {
    publishServerStatus("online");
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const maintenanceResponse = error.response?.headers?.["x-tripleside-maintenance"] === "1";
    const detail = error.response?.data?.detail;
    const detailMessage = Array.isArray(detail)
      ? detail.map((item) => item?.msg).filter(Boolean).join(". ")
      : typeof detail === "string"
        ? detail
        : "";
    if (!error.response) {
      const offline = typeof navigator !== "undefined" && navigator.onLine === false;
      error.userMessage = offline
        ? "Koneksi internet terputus. Data Anda tetap aman; sambungkan kembali lalu coba lagi."
        : "Server sedang diperbarui atau dimulai ulang. Data Anda tetap aman; silakan coba lagi sebentar.";
      publishServerStatus(offline ? "offline" : "maintenance", error.userMessage);
    } else if (maintenanceResponse || status === 502 || status === 504) {
      error.userMessage = "Server sedang diperbarui atau dimulai ulang. Data Anda tetap aman; silakan coba lagi sebentar.";
      publishServerStatus("maintenance", error.userMessage);
    } else {
      error.userMessage =
        detailMessage ||
        (status === 404
          ? "Data atau endpoint yang diminta tidak ditemukan."
          : "Permintaan gagal. Silakan coba lagi.");
    }

    return Promise.reject(error);
  }
);

export const fmtPrice = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n || 0);

export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n || 0);
